import { render, staticRenderFns } from "./auditors.vue?vue&type=template&id=6c32cfc1&"
import script from "./auditors.vue?vue&type=script&lang=js&"
export * from "./auditors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports